export const doesBrowserSupportPushNotifications: () => boolean = () =>
  'PushManager' in window &&
  'serviceWorker' in window.navigator &&
  'ServiceWorkerRegistration' in window &&
  typeof window.ServiceWorkerRegistration.prototype.showNotification === 'function';
